import { render, staticRenderFns } from "./BuyableImg.vue?vue&type=template&id=25d52a70&"
import script from "./BuyableImg.vue?vue&type=script&lang=js&"
export * from "./BuyableImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports